<template>
  <table class="table" :class="{sortable: sortable}">
    <thead>
    <tr>
      <th @click="sortBy('tier')" :class="{active: sortKey === 'tier'}"><span>Tier
        <span v-if="sortKey === 'tier'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th @click="sortBy('full_name')" :class="{active: sortKey === 'full_name'}" class="col__name"><span>Name
        <span v-if="sortKey === 'full_name'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
      :class="[column.classNames, sortKey === column.name ? 'active' : null]"><span>{{ column.label }}
        <span v-if="sortKey === column.name" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th class="col__customer-types" v-if="displayTypes"><span class="col__customer-type">Type</span><span class="col__customer-sub-type">Sub</span></th>
    </tr>
    </thead>

    <tbody v-if="rows.length > 0" class="table__body">
    <tr v-for="row in rows" :key="row.id" @click="handleRowClick(row, $event)">
      <td>
        <div class="col__tier"
             :class="{'col__tier--2': row.tier === 2 || row.ald_customer_tier === 2, 'col__tier--3': row.tier === 3 || row.ald_customer_tier == 3, 'col__tier--1': row.tier === 1 || row.ald_customer_tier === 1 }">
          {{ row.tier || row.ald_customer_tier || '?' }}
        </div>
      </td>
      <td>
        <div class="col__name col__name--cell">
          <div class="col__user-picture" v-bind:style="{ 'background': 'url(' + row?.avatar?.url + ')'}" v-if="row?.avatar?.url || row?.avatar?.url"></div>
          <div v-else><span class="col__avatar">{{ getAvatar(row) }}</span></div>
          <div>{{ getFullName(row) }}</div>
        </div>
      </td>
      <td v-for="field in fields" :key="field.name" :class="field.classNames && field.classNames(row)">
        <div class="col__field" v-html="formatField(row, field)"></div>
      </td>
      <CustomerTypesCell
        v-if="displayTypes"
        :customerTypes="row.types"
        :customerSubTypes="row.sub_types"
      />
      <!-- <td class="customer-types-cell" v-if="displayTypes">
        <div class="customer-types-container">
          <div v-for="customer_type in row.types.sort((a, b) => a.id - b.id)" :key="customer_type.name" class="customer-type-container" v-bind:style="{ 'background-color': customer_type?.type_color?.hex_value }">{{ customer_type.name }}</div>
        </div>
      </td> -->
    </tr>
    </tbody>
    <tbody v-if="rows.length === 0 && requestCompleted">
    <tr>
      <td colspan="3">
        <div class="col-no-results">{{ noData }}</div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import CustomerTypesCell from '../components/CustomerTypesCell.vue';

export default {
  name: 'Table',
  components: { CustomerTypesCell },
  emits: ['rowClick', 'updateSort'],
  props: {
    rows: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    requestCompleted: {
      type: Boolean,
      default: true
    },
    displayTypes: {
      type: Boolean,
      default: true
    },
    sortable: {
      type: Boolean,
      default: false
    },
    noData: {
      type: String,
      default: "No data found!"
    }
  },
  data() {
    return {
      sortKey: 'full_name',
      reverse: false,
    }
  },
  methods: {
    filteredCustomerSubTypes(customer) {
      console.log(customer)
    },
    formatField(row, field) {
      if (!field.format) {
        return row[field.name];
      }

      return field.format(row);
    },
    getAvatar(row) {
      if (row.customer) {
        return row.customer.first_name?.charAt(0).toUpperCase() + row.customer.last_name?.charAt(0).toUpperCase();
      }
      return row.first_name?.charAt(0).toUpperCase() + row.last_name?.charAt(0).toUpperCase();
    },
    getFullName(row) {
      if (row.customer) {
        return row.customer.first_name + " " + row.customer.last_name;
      }
      return row.first_name + " " + row.last_name;
    },
    handleRowClick(id, event) {
      if (event.target.tagName === 'A') {
        return;
      }
      this.$emit('rowClick', id);
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;

      this.sortKey = sortKey;
      this.$emit('updateSort', sortKey, this.reverse ? 'desc' : 'asc');
    },
  }
}
</script>

<style scoped>

.table th:last-child {
  text-align: right;
}
.col__avatar {
  background-color: #A5C3D0;
  color: #ffffff;
  border-radius: 50%;
  text-align: center;
}
.col__customer-types {
  width: 215px;
  text-align: right;
}

.col__customer-type {
  margin-right: 80px;
}

.col__tier {
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
}

.col__avatar {
  width: 44px;
  height: 44px;
  line-height: 44px;
}

.col__name {
  max-width: 240px;
}

.col__last-seeded {
  text-align: right;
  width: 300px;
  padding-right: 50px;
}

.col__last-seeded-date {
  text-align: right;
  padding-right: 50px;
}

.col__tier--1 {
  color: #A5C3D0;
}

.col__tier--2 {
  color: #F4C474;
}

.col__tier--3 {
  color: #DF9B85;
}

.col__avatar {
  display: inline-block;
  margin-right: 9px;
  background-color: #000;
}

.col__user-picture {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  text-align: center;
  line-height: 44px;
  display: inline-block;
  margin-right: 9px;
  background-position: center center !important;
  background-size: 120% auto !important;
  background-repeat: no-repeat !important;
}

.col__status {
  text-transform: capitalize;
}

.col__status--yellow {
  color: #D4B721;
}

.col__status--red {
  color: #D43F21;
}

.col__status--green {
  color: #089E56;
}

.col__status--gray {
  color: #C4C4C4;
}

.table .col__name:last-child {
  text-align: right;
}

.table__body tr:hover {
  background-color: #E5E5E5;;
  cursor: pointer;
}

.table th:first-child {
  width: 60px;
}

.icon--down {
  position: absolute;
  width: 11px;
  height: 6px;
  right: -14px;
  top: 2px;
  background-position: bottom center;
}

.icon--up {
  transform: rotate(180deg);
}

th > span {
  position: relative;
}

.sortable th.active {
  text-decoration: underline;
}

.sortable th:hover {
  cursor: pointer;
}

table:not(.sortable) .icon {
  display: none;
}

.customer-types-container,
.customer-subtypes-container {
  display: grid;
  grid-template-columns: 70px;
  grid-template-rows: 20px 20px 20px;
  row-gap: 3px;
  column-gap: 2px;
  direction: rtl;
  grid-auto-flow: column;
}
.customer-type-container,
.customer-subtype-container {
  font-size: 0.50rem;
  padding: 4px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #FFFFFF;
  borer: 1px solid #E5E5E5;
}
@media screen and (max-width: 992px) {
  .table th:first-child {
    width: 35px;
  }

  .table th:last-child {
    text-align: right;
  }
  .col__customer-types {
    width: 150px;
  }

  .col__customer-type {
    margin-right: 45px;
  }

  .col__name > div {
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .col__field {
    width: 110px;
  }
  .col__avatar {
    margin-bottom: 5px;
  }
  .col__name:not(:first-child) {
    max-width: 140px;
  }

  .col__name--cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 15px;
  }

  .col__last-seeded {
    display: flex;
    align-items: flex-end;
    width: 95px;
  }

  .col__last-seeded-date {
    text-align: left;
  }

  .customer-types-container {
    display: grid;
    grid-template-columns: 70px;
    grid-template-rows: 20px 20px 20px;
    row-gap: 3px;
    column-gap: 2px;
    direction: rtl;
    grid-auto-flow: column;
  }
}

@media screen and (min-width: 992px) {
  .col__name {
    display: flex;
    align-items: center;
    width: 300px;
  }
}
</style>

